import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  return (
    <div className="flex min-h-[70vh] items-center justify-center px-4">
      <div className="w-full max-w-md rounded-2xl bg-white p-10 text-center ring-1 ring-slate-100 shadow-sm" data-testid="payment-cancel">
        <XCircle className="mx-auto h-10 w-10 text-slate-400" />
        <h1 className="mt-5 font-display text-2xl font-bold text-slate-900">Payment cancelled</h1>
        <p className="mt-2 text-sm text-slate-600">No charge was made. Your items are still in your cart whenever you're ready.</p>
        <div className="mt-6 flex justify-center gap-3">
          <Link to="/checkout"><Button className="btn-metallic font-semibold">Return to checkout</Button></Link>
          <Link to="/shop"><Button variant="outline" className="border-slate-200 bg-transparent text-slate-700 hover:bg-slate-100">Keep shopping</Button></Link>
        </div>
      </div>
    </div>
  );
}
